/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectClientTermsResource
 */
export interface ProjectClientTermsResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectClientTermsResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectClientTermsResource
     */
    url: string;
}

/**
 * Check if a given object implements the ProjectClientTermsResource interface.
 */
export function instanceOfProjectClientTermsResource(value: object): value is ProjectClientTermsResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ProjectClientTermsResourceFromJSON(json: any): ProjectClientTermsResource {
    return ProjectClientTermsResourceFromJSONTyped(json, false);
}

export function ProjectClientTermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectClientTermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
    };
}

export function ProjectClientTermsResourceToJSON(value?: ProjectClientTermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
    };
}

